module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-11-417e7f512ed911863847f9bd6268cccc.png";